import Vuetify from 'vuetify';
import { VBottomSheet, VSheet } from 'vuetify/lib';
import Vue from 'vue';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';

import NsAvatar from './avatar/NsAvatar.vue';
import NsBadge from './badge/NsBadge.vue';
import NsSelect from './form-elements/NsSelect.vue';
import NsIcon from './icons/NsIcon.vue';
import NsIconset from './icons/NsIconset.vue';
import NsPassword from './password/NsPassword.vue';
import NsAlert from './ns-alert/NsAlert.vue';
import NsToast from './toast/NsToast.vue';
import NsModal from './ns-modal/NsModal.vue';
import NsBifrostButton from './buttons/NsBifrostButton.vue';
import NsCreditCard from './form-elements/credit-card/NsCreditCard.vue';
import NsCreditCardDate from './form-elements/credit-card/NsCreditCardDate.vue';
import NsCreditCardForm from './form-elements/credit-card/NsCreditCardForm.vue';

window.Vue = Vue;
Vue.config.silent = true;

Vue.use(Vuetify, {
  theme: { dark: false },
  components: {
    VBottomSheet,
    VSheet
  }
});
// // To allow use as module (npm/webpack/etc.) export component

export {
  NsAvatar,
  NsBadge,
  NsSelect,
  NsIcon,
  NsIconset,
  NsPassword,
  NsAlert,
  NsToast,
  NsModal,
  NsBifrostButton,
  NsCreditCard,
  NsCreditCardDate,
  NsCreditCardForm
};
